

export const calculateQuarterly = (val) => {
    return val * 92;
    // return calculateYearly(val) / 4;
}

export const calculateYearly = (val) => {
    return calculateQuarterly(val) * 4;
    // return val * 365.25;
}

export const calculateLoanAmount = (balance, vendorRate) => {
    return balance / (1 - vendorRate);
}

export const calculateFinanceFee = (opt) => {
    switch(opt.Provider) {
        case 'Humm':
            //humm includes the establishment fee
            return ((opt.LoanTerm) * opt.OngoingFee * opt.FeeMultiplier) + opt.EstFee;
        default:
            //all the others just have the repayment count + ongoing fee * multiplier
            return (opt.RepaymentCount * opt.OngoingFee * opt.FeeMultiplier);
    }
}

export const calculateFinanceSaleAmount = (opt, loanAmount, deposit) => {
    switch(opt.Provider) {
        case 'Plenti Green':
            return loanAmount;
        default:
            return loanAmount + deposit;
    }
}

export const calculateFinanceTotalPayable = (opt, loanAmount, fees) => {
    switch(opt.Provider) {
        case 'Plenti Green':
            return loanAmount + opt.EstFee;
        default:
            return fees + loanAmount;
    }
}

export const calculateFinanceMonthlyRepayment = (opt, balanceAmount) => {
    switch(opt.Provider) {
        case 'Plenti Green':
            var loan = calculateLoanAmount(balanceAmount, (opt.VendorRateInc / 100));
            var mRate = (opt.InterestRate / 100) / 12;
            var pmt = PMT(mRate, opt.LoanTerm, (loan - 1000 + opt.EstFee) * -1);
            return pmt + opt.OngoingFee;
        case 'Plenti':
            var fee = calculateFinanceFee(opt);
            var loan = calculateLoanAmount(balanceAmount, (opt.VendorRateInc / 100));
            return (fee + loan) / opt.LoanTerm;
    }
}

export const calculateFinanceFortnightRepayment = (opt, balanceAmount) => {
    switch (opt.Provider) {
        case 'Plenti Green':
            return calculateFinanceMonthlyRepayment(opt, balanceAmount) * 12 / 26;
        case 'Plenti':
            return calculateFinanceMonthlyRepayment(opt, balanceAmount) * 12 / 26;
        case 'Brighte':
            var fee = calculateFinanceFee(opt);
            var loan = calculateLoanAmount(balanceAmount, (opt.VendorRateInc / 100));
            return (loan + fee) / opt.RepaymentCount;
        case 'Humm':
            var fee = calculateFinanceFee(opt);
            var loan = calculateLoanAmount(balanceAmount, (opt.VendorRateInc / 100));
            return (loan + fee) / opt.RepaymentCount;
        default:

    }
}

export const calculateFinanceWeeklyRepayment = (opt, balanceAmount) => {
    switch (opt.Provider) {
        case 'Plenti Green':
            return calculateFinanceMonthlyRepayment(opt, balanceAmount) * 12 / 52;
        case 'Plenti':
            return calculateFinanceMonthlyRepayment(opt, balanceAmount) * 12 / 52;
        case 'Brighte':
            var fee = calculateFinanceFee(opt);
            var loan = calculateLoanAmount(balanceAmount, (opt.VendorRateInc / 100));
            return ((loan + fee) / opt.RepaymentCount) * 26 / 52;
        case 'Humm':
            var fee = calculateFinanceFee(opt);
            var loan = calculateLoanAmount(balanceAmount, (opt.VendorRateInc / 100));
            return ((loan + fee) / opt.RepaymentCount) * 26 / 52;
        default:

    }
}

export const PMT = (rate, nper, pv, fv, type) => {
    /*
     * rate   - interest rate per month
     * nper   - number of periods (months)
     * pv   - present value
     * fv   - future value
     * type - when the payments are due:
     *        0: end of the period, e.g. end of month (default)
     *        1: beginning of period
     */
    let pmt, pvif;

    fv || (fv = 0);
    type || (type = 0);

    if (rate === 0)
      return -(pv + fv) / nper;

    pvif = Math.pow(1 + rate, nper);
    pmt = - rate * (pv * pvif + fv) / (pvif - 1);

    if (type === 1)
      pmt /= (1 + rate);
    return pmt;
  }